(function(){
  var TEMPLATE_ID = 'gaCollectionFeaturedLookOverride';
  var observer = null;
  var scheduled = false;

  function applyFeaturedLookOverride(){
    var template = document.getElementById(TEMPLATE_ID);
    if (!template || !template.content) return;

    var grid = document.getElementById('product-grid');
    if (!grid) return;

    var existingManual = grid.querySelector('.ga-collection-look[data-ga-manual-look="true"]');
    if (existingManual) return;

    var primaryAuto = grid.querySelector('.ga-collection-look[data-ga-look-position="primary"]:not([data-ga-manual-look="true"])');
    if (primaryAuto) primaryAuto.remove();

    var products = Array.prototype.filter.call(grid.children, function(child){
      return !child.classList.contains('ga-collection-look');
    });

    if (!products.length) return;

    var primaryIndex = products.length >= 8
      ? 7
      : Math.max(0, Math.floor(products.length / 2) - 1);

    var node = template.content.firstElementChild.cloneNode(true);
    products[primaryIndex].insertAdjacentElement('afterend', node);
  }

  function scheduleApply(){
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function(){
      scheduled = false;
      applyFeaturedLookOverride();
    });
  }

  function initFeaturedLookOverride(){
    var template = document.getElementById(TEMPLATE_ID);
    if (!template) return;

    applyFeaturedLookOverride();

    var container = document.getElementById('ProductGridContainer');
    if (!container || observer) return;

    observer = new MutationObserver(function(){
      scheduleApply();
    });

    observer.observe(container, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFeaturedLookOverride);
  } else {
    initFeaturedLookOverride();
  }

  document.addEventListener('shopify:section:load', function(){
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    initFeaturedLookOverride();
  });
})();
